export const folderExceptions = {
  onReassignUser: "Error al reasignar el expediente",
  onReassignCollaborator: "Error al reasignar el colaborador",
  updateAnalysisForm: "Error al guardar el análisis del expediente",
  fetchFolderHistory: "Error al obtener el historial del expediente",
  toggleFolderActive: "Error al cambiar el estatus del expediente",
  addNotesToFolder: "Error al actualizar las notas del expediente",
  createFolder: "Error al crear expediente",
  updateFolder: "Error al modificar expediente",
  fetchFolderById: "El expediente con el id proporcionado no existe",
  fetchFolderRequirements: "Error al obtener los requisitos del expediente",
  fetchAllFolders: "Error al obtener los expedientes",
  fetchMyFolders: "Error al obtener los expedientes",
  downloadFolderAsZip: "Error al descargar archivos del expediente",
  sendFolderStatusEmail: "Error al enviar correo de estatus del expediente",
  fetchFolderPdf: "El reporte del inquilino no está completo o no existe",
  completeFileFolder: "El reporte del inquilino aún no está completado",
  isNotAdminOrOps: "No tienes permisos para realizar esta acción",
  subfoldersAreNotReady:
    "No se han completado todos los requisitos del expediente",
  folderAnalysis: "No se ha podido obtener el análisis del expediente",
};

export const folderExceptionsMessage: { [key: string]: string } = {
  "3000":
    "El reporte del inquilino debe estar en estatus 'En Progreso' o 'Completado' para su previsualización",
  "3001": "El reporte del inquilino no está activo para su previsualización",
  "3002": "El reporte del inquilino ya se encuentra en estatus 'Completado'",
  "3003": "El reporte del inquilino no se encuentra activo para ser completado",
  "3004":
    "El reporte del inquilino debe estar en estatus 'En Progreso' para ser completado",
  "3999": "Ha ocurrido un error inesperado",
};
